export const LOAN_CONSENT_COPY =
  'I consent to receive promotional messages by phone, email, and/or text message. This consent is not a condition of any loan approval. Message and data rates may apply.';

export const CREDIT_CONSENT_COPY =
  'I consent to receive promotional messages by phone, email, and/or text message. This consent is not a condition of any credit approval. Message and data rates may apply.';

export const LOAN_CREDIT_AUTH_COPY =
  'By checking the box, I authorize Eagle Loan Co. to obtain a Consumer Credit Report on me for the purposes of obtaining a personal loan.';

export const CREDIT_AUTH_COPY =
  'By checking the box, I authorize Sims Furniture to obtain a Consumer Credit Report on me for the purposes of obtaining credit.';

export const LOAN_TERMS_URL = 'https://www.eagle.com/terms/';

export const CREDIT_TERMS_URL =
  'https://www.simsfurnitureco.com/pages/terms-conditions';
